import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/itemsForResource.js'
import axios from 'axios'


export const useWebconnexIntegrationStore = defineStore('webconnexIntegration', {
  id: 'webconnexIntegration',
  state: () => ({
    api: '/api/v1/webconnex-integrations'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions,
    async fetchItemsByFundraiserId(fundraiserId, params) {
      return await this.fetchItems({
        fundraiser_id: fundraiserId,
        ...params,
      })
    },
    async itemEnable(webconnexIntegrationId) {
      const { data } =  await axios.post(`${this.api}/${webconnexIntegrationId}/disable`)
      return data
    },
    async itemDisable(webconnexIntegrationId) {
      const { data } =  await axios.post(`${this.api}/${webconnexIntegrationId}/disable`)
      return data
    }
  }
})
